import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";

@Entity('confcall_guests')

export class ConfGuestEntity {

    @PrimaryGeneratedColumn('increment',{name:'id'}) Id: number;
    
    @Column({
        type: 'varchar',
        nullable: true,
        length: '500',
        name: 'meeting_id',
    })
    meetingId: string;  
    @Column({
        type: 'int',
        nullable:true,
        name: 'user_id'
    })
    userId: number;
    @Column({
        type: 'int',
        nullable:true,
        name: 'admin_id'
    })
    adminId: number;
     
}